import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

const useStyles = makeStyles(theme => ({
  root: {
    '& .swagger-ui, .info h1, .info h2, .info h3, .info h4, .info h': {
      'font-family': 'inherit',
      color: theme.palette.text.primary,
    },
    '& .scheme-container': {
      'background-color': theme.palette.background.default,
    },
    '& .opblock-tag, .opblock-tag small, table thead tr td, table thead tr th':
      {
        color: theme.palette.text.primary,
        'border-color': theme.palette.divider,
      },
    '& section.models, section.models.is-open h4': {
      'border-color': theme.palette.divider,
    },
    '& .opblock .opblock-summary-description, .parameter__type, table.headers td, .model-title, .model .property.primitive, section h3':
      {
        color: theme.palette.text.secondary,
      },
    '& .opblock .opblock-summary-operation-id, .opblock .opblock-summary-path, .opblock .opblock-summary-path__deprecated, .opblock .opblock-section-header h4, .parameter__name, .response-col_status, .response-col_links, .responses-inner h4, .swagger-ui .responses-inner h5, .opblock-section-header .btn, .tab li, .info li, .info p, .info table, section.models h4, .info .title, table.model tr.description, .property-row':
      {
        color: theme.palette.text.primary,
      },
    '& .opblock .opblock-section-header, .model-box, section.models .model-container':
      {
        background: theme.palette.background.default,
      },
    '& .prop-format, .parameter__in': {
      color: theme.palette.text.disabled,
    },
    '& ': {
      color: theme.palette.text.primary,
      'border-color': theme.palette.divider,
    },
    '& .opblock-description-wrapper p, .opblock-external-docs-wrapper p, .opblock-title_normal p, .response-control-media-type__accept-message, .opblock .opblock-section-header>label, .scheme-container .schemes>label, .info .base-url, .model':
      {
        color: theme.palette.text.hint,
      },
    '& .parameter__name.required:after': {
      color: theme.palette.warning.dark,
    },
    '& .prop-type': {
      color: theme.palette.primary.main,
    },
  },
}));

type Props = {
  definition: string;
};

// Source: https://github.com/swagger-api/swagger-ui/issues/3725#issuecomment-334899276
const DisableTryItOutPlugin = () => ({
  statePlugins: {
    spec: {
      wrapSelectors: {
        allowTryItOutFor: () => () => false,
      },
    },
  },
});

// Source: https://github.com/swagger-api/swagger-ui/issues/3314#issuecomment-378309496
const DisableAuthorizePlugin = () => ({
  wrapComponents: {
    authorizeBtn: () => () => null,
  },
});

export const OpenApiDefinitionWidget = ({ definition }: Props) => {
  const classes = useStyles();

  // Due to a bug in the swagger-ui-react component, the component needs
  // to be created without content first.
  const [def, setDef] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => setDef(definition), 0);
    return () => clearTimeout(timer);
  }, [definition, setDef]);

  // customization from the upstream version
  const plugins = [DisableTryItOutPlugin, DisableAuthorizePlugin];

  return (
    <div className={classes.root}>
      <SwaggerUI spec={def} plugins={plugins} />
    </div>
  );
};
